/**
 * Hide the mobileMenu.
 *
 * @param {boolean} focus Set focus.
 */
const hideMobileMenu = ( focus = false ) => {
    const mobileMenu = document.getElementById( 'mobile-menu' ),
        mobileMenuToggle = document.getElementById( 'menuToggle' );

    mobileMenu.setAttribute( 'aria-hidden', true );
    mobileMenuToggle.setAttribute( 'aria-hidden', true );

    if ( document.body.classList.contains( 'menu-active' ) ) {
        document.body.classList.remove( 'menu-active' );
    }

    if( !! focus ) {
        mobileMenuToggle.focus();
    }
}

export default hideMobileMenu;


